/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTaskNotificationPhase } from './rolloutTaskNotificationPhase';
import { RolloutType } from './rolloutType';
import { ScheduledNotificationBefore } from './scheduledNotificationBefore';


export interface RolloutNotificationConfigResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    /**
     * Whether the notification is enabled.
     */
    enabled: boolean;
    rollout_type: RolloutType;
    phase: RolloutTaskNotificationPhase;
    /**
     * List of triggers for the notification if applicable.
     */
    triggers?: Array<ScheduledNotificationBefore>;
    /**
     * Name of the notification.
     */
    name: string;
}
export namespace RolloutNotificationConfigResponse {
}


